/**
 * 一些工具方法
 */
import { Page, Utils } from '@gov-mo/mpaas-js-bridge';
import { getAuthURLByPlatform } from './platform';

/**
 * 身份证校验
 * @param {*} str
 */

export const valideIDCard = (str) => {
  // 澳门&香港 例：H1234567890
  const Macao = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
  // 台湾 例： 1234567890B
  const Taiwan = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
  // 1.大陆，可含X
  // eslint-disable-next-line max-len
  const Dalu = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;

  return Macao.test(str) || Taiwan.test(str) || Dalu.test(str);
};

/**
 * 手機號校驗
 * @param {*} str
 */
export const validePhone = (str) => /^1[3|4|5|7|8][0-9]{9}$/.test(str);

/**
 * 密碼校驗 6-16 數字或字母
 * @param {*} str
 */
export const validePassword = (str) => /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(str);

/**
 * 邮箱地址校验
 * @param {*} str
 */
export const valideEmail = (str) =>
  /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(str);


export const isMobile = () => {
  if (window.isMobileByApp) {
    return navigator.userAgent.indexOf('mPaaSClient') > -1;
  }
  if (
    // eslint-disable-next-line
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.exec(
      navigator.userAgent,
    )
  ) {
    return true;
  }
  return false;
};

export const isIOS = () => {
  const ua = window.navigator.userAgent.toLocaleLowerCase();
  return /iphone|ipad|ipod/.test(ua);
};

/**
 * 相对路径转绝对路径
 * @param {string} url 相对路径
 */
const relative2absolute = function (url: string) {
  if (url.startsWith('/')) {
    return `${window.location.origin}${window.routerBase}${url.substring(1)}`;
  }
  return new URL(url, window.location.href).href;
};

/**
 * 经封装的Page.openPage方法
 * 默認情況下openPage只能打開帶域名的完整路徑，前端路由跳轉地址是可以不帶域名的，
 * 該方法對路徑作了封裝，將相對路徑轉換成完整路徑，使APP中的路徑跳轉
 * @param {string} router 相对路径
 */
export const openPageRelativePath = (route, options = {}) => {
  Page.openPage({
    path: relative2absolute(route),
    options: { hideNavigationBar: false, ...options },
  });
};

/**
 * 解析申請人姓名，返回姓和名
 * @param name
 * @returns
 */
export const formatName = (name) => {
  if (!name) return ['', ''];
  if (name.includes(',')) {
    const [lastName = '', firstName = ''] = name.split(',');
    return [lastName, firstName];
  }
  return [name.slice(0, 1), name.slice(1)];
};

/**
 * 解析申請外國姓名，返回姓和名
 * @param name
 * @returns
 */
export const formatForeignName = (name) => {
  if (!name) return ['', ''];
  // 优先逗号分隔
  if (name.includes(',')) {
    const [lastName = '', firstName = ''] = name.split(',');
    return [lastName, firstName];
  }
  // 空格分隔
  const index = name.indexOf(' ');
  if (index !== -1) {
    return [name.slice(index + 1)?.trim(), name.slice(0, index)];
  }
  // 仅单一单词
  return [name, ''];
};

/**
 * 如果是移動端瀏覽器訪問則導向APP的引流頁面
 * @returns
 */
export const checkBrowser = () => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  // 商社通分享地址：https://app-res-sit.ab.gov.mo/share/share.html
  // 一戶通分享地址：https://app-res-sit.mo.gov.mo/#/share
  const isValid = isMobile() ? Utils.isGovMoApp() : true;
  if (!isValid) {
    let redirect = getAuthURLByPlatform()?.replace('www', 'app-res');
    // const search = '/share/share.html';
    const search = '/#/share';
    redirect += `${search}?tar=${encodeURIComponent(window.location.href)}&appId=${GOV_MO.APP_ID}`;
    window.location.href = redirect;
    return false;
  }
  return isValid;
};
